<template>
    <div>
        <div class="page-header pr-0">
            <h2>
                <a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a>
            </h2>
            <ol class="breadcrumbs">
                <li class="active"><span>RENTAR HABITACIÓN</span></li>
            </ol>
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">RENTAR HABITACIÓN</h3>
            </div>
            <div class="card-body">
                <div class="card">
                    <div class="card-header">Datos de la habitación</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6 form-group">
                                <div class="row">
                                    <div class="col-4">Nombre</div>
                                    <div class="col-8">
                                        <strong>{{ room.name }}</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 form-group">
                                <div class="row">
                                    <div class="col-4">Detalles</div>
                                    <div class="col-8">
                                        <strong>{{ room.description }}</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 form-group">
                                <div class="row">
                                    <div class="col-4">Categoría</div>
                                    <div class="col-8">
                                        <strong>{{ room.category.description }}</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 form-group">
                                <div class="row">
                                    <div class="col-4">Estado</div>
                                    <div class="col-8">
                    <span
                        class="badge badge-pill"
                        :class="onGetStatus(room.status)"
                    >{{ room.status }}</span
                    >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">Datos del cliente</div>
                    <div class="card-body">
                        <div
                            class="form-group"
                            :class="{ 'has-danger': errors.customer_id }"
                        >
                            <label class="control-label font-weight-bold text-info">
                                Cliente
                                <a href="#" @click.prevent="showDialogNewPerson = true"
                                >[+ Nuevo]</a
                                >
                            </label>
                            <el-select
                                v-model="form.customer_id"
                                filterable
                                remote
                                class="border-left rounded-left border-info"
                                popper-class="el-select-customers"
                                placeholder="Escriba el nombre o número de documento del cliente"
                                :remote-method="searchRemoteCustomers"
                                :loading="loading"
                                @change="changeCustomer"
                            >
                                <el-option
                                    v-for="option in customers"
                                    :key="option.id"
                                    :value="option.id"
                                    :label="option.description"
                                ></el-option>
                            </el-select>
                            <el-checkbox v-model="search_item_by_barcode"
                                         :disabled="recordItem != null">Buscar por
                                código de
                                barras
                            </el-checkbox>
                            <small
                                class="form-control-feedback"
                                v-if="errors.customer_id"
                                v-text="errors.customer_id[0]"
                            ></small>
                        </div>
                        <div class="row">
                            <div
                                class="form-group col-12 col-md-6"
                                :class="{ 'has-danger': errors['customer.name'] }"
                            >
                                <label>Nombres</label>
                                <el-input v-model="form.customer.name"></el-input>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors['customer.name']"
                                    v-text="errors['customer.name'][0]"
                                ></small>
                            </div>
                            <div
                                class="form-group col-12 col-md-6"
                                :class="{ 'has-danger': errors['customer.address'] }"
                            >
                                <label>Dirección</label>
                                <el-input v-model="form.customer.address"></el-input>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors['customer.address']"
                                    v-text="errors['customer.address'][0]"
                                ></small>
                            </div>
                            <div
                                class="form-group col-12 col-md-10"
                                :class="{ 'has-danger': errors.notes }"
                            >
                                <label for="notes">Notas</label>
                                <el-input v-model="form.notes"></el-input>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors.notes"
                                    v-text="errors.notes[0]"
                                ></small>
                            </div>
                            <div
                                class="form-group col-12 col-md-2"
                                :class="{ 'has-danger': errors.towels }"
                            >
                                <label for="notes">Toallas</label>
                                <el-input v-model="form.towels" type="number"></el-input>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors.towels"
                                    v-text="errors.towels[0]"
                                ></small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">Datos del alojamiento</div>
                    <div class="card-body">
                        <div class="row">
                            <div
                                class="col-12 col-md-4 form-group"
                                :class="{ 'has-danger': errors.hotel_rate_id }"
                            >
                                <label for="rate">Tarifa</label>
                                <el-select
                                    v-model="form.hotel_rate_id"
                                    @change="onSelectedRate"
                                >
                                    <el-option
                                        v-for="option in room.rates"
                                        :key="option.hotel_rate_id"
                                        :value="option.hotel_rate_id"
                                        :label="option.rate.description"
                                    ></el-option>
                                </el-select>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors.hotel_rate_id"
                                    v-text="errors.hotel_rate_id[0]"
                                ></small>
                            </div>

                            <!-- afectación igv -->
                            <div
                                class="col-12 col-md-4 form-group"
                                :class="{ 'has-danger': errors.affectation_igv_type_id }"
                            >
                                <label for="rate">Tipo de afectación</label>

                                <el-select
                                    v-model="form.affectation_igv_type_id"
                                >
                                    <el-option
                                        v-for="option in getAllowedAffectationIgvTypes"
                                        :key="option.id"
                                        :value="option.id"
                                        :label="option.description"
                                    ></el-option>
                                </el-select>

                                <small
                                    class="form-control-feedback"
                                    v-if="errors.affectation_igv_type_id"
                                    v-text="errors.affectation_igv_type_id[0]"
                                ></small>
                            </div>
                            <!-- afectación igv -->

                            <div
                                class="col-12 form-group"
                                :class="{ 'has-danger': errors.rate_price, 'col-md-2': rate, 'col-md-4': !rate }"
                            >
                                <label for="rate">Precio</label>
                                <el-input-number
                                    v-model="form.rate_price"
                                    controls-position="right"
                                    :min="0"
                                    @change="onUpdateTotalToPay"
                                    :disabled="!rate"
                                ></el-input-number>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors.rate_price"
                                    v-text="errors.rate_price[0]"
                                ></small>
                            </div>


                            <div
                                class="col-12 col-md-2 form-group"
                                :class="{ 'has-danger': errors.duration }"
                                v-if="rate"
                            >
                                <label for="rate">Cant. noches</label>
                                <el-input-number
                                    v-model="form.duration"
                                    controls-position="right"
                                    @change="onUpdateTotalToPay"
                                    :min="1"
                                ></el-input-number>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors.duration"
                                    v-text="errors.duration[0]"
                                ></small>
                            </div>
                            <div class="col-12 col-md-4 text-center">
                                <h6>
                                    Total a pagar:
                                    <br/>
                                    <span class="h5">{{ form.total_to_pay }}</span>
                                </h6>
                            </div>
                            <div
                                class="col-12 col-md-4 form-group"
                                :class="{ 'has-danger': errors.quantity_persons }"
                            >
                                <label>Cant. de personas</label>
                                <el-select v-model="form.quantity_persons">
                                    <el-option value="1" label="1"></el-option>
                                    <el-option value="2" label="2"></el-option>
                                    <el-option value="3" label="3"></el-option>
                                    <el-option value="4" label="4"></el-option>
                                    <el-option value="5" label="5"></el-option>
                                    <el-option value="6" label="6"></el-option>
                                </el-select>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors.quantity_persons"
                                    v-text="errors.quantity_persons[0]"
                                ></small>
                            </div>
                            <div
                                class="col-12 col-md-4 form-group"
                                :class="{ 'has-danger': errors.payment_status }"
                            >
                                <label>Estado de pago</label>
                                <el-select
                                    v-model="form.payment_status"
                                    @change="onChangeStatusPayment"
                                >
                                    <el-option value="PAID" label="Pagado"></el-option>
                                    <el-option value="DEBT" label="Falta pagar"></el-option>
                                </el-select>
                                <small
                                    class="form-control-feedback"
                                    v-if="errors.payment_status"
                                    v-text="errors.payment_status[0]"
                                ></small>
                            </div>


                            <div class="col-12 col-md-6">
                                <div class="row">
                                    <h4 class="col-12">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="M217 28.098v455.804l142-42.597V70.697zm159.938 26.88l.062 2.327V87h16V55zM119 55v117.27h18V73h62V55zm258 50v16h16v-16zm0 34v236h16V139zm-240 58.727V233H41v46h96v35.273L195.273 256zM244 232c6.627 0 12 10.745 12 24s-5.373 24-12 24s-12-10.745-12-24s5.373-24 12-24M137 339.73h-18V448h18zM377 393v14h16v-14zm0 32v23h16v-23zM32 471v18h167v-18zm290.652 0l-60 18H480v-18z"/>
                                        </svg>
                                        Check-in
                                    </h4>

                                    <div class="col-6 form-group">
                                        <label>Fecha de entrada</label>
                                        <el-date-picker
                                            v-model="form.input_date"
                                            type="date"
                                            placeholder="Seleccione una fecha"
                                            value-format="yyyy-MM-dd"
                                            disabled
                                        ></el-date-picker>
                                        <small
                                            class="form-control-feedback"
                                            v-if="errors.input_date"
                                            v-text="errors.input_date[0]"
                                        ></small>
                                    </div>
                                    <div class="col-6 form-group">
                                        <label>Hora de entrada</label>
                                        <el-input v-model="form.input_time" placeholder="HH:MM">
                                        </el-input>
                                        <small
                                            class="form-control-feedback"
                                            v-if="errors.input_time"
                                            v-text="errors.input_time[0]"
                                        ></small>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="row">
                                    <h4 class="col-12">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1">
                                                <path d="M13.5 12.5h10m-4-4l4 4l-4 4M7 11l-1.5 1.5L7 14l1.499-1.5zm9.5 4.5v6h-6m0-18h6v6"/>
                                                <path d="m10.5 23.5l-10-2v-18l10-2z"/>
                                            </g>
                                        </svg>
                                        Check-out
                                    </h4>

                                    <div
                                        class="col-6 form-group"
                                        :class="{ 'has-danger': errors.output_date }"
                                    >
                                        <label>Fecha de salida</label>
                                        <el-date-picker
                                            v-model="form.output_date"
                                            type="date"
                                            placeholder="Seleccione una fecha"
                                            value-format="yyyy-MM-dd"
                                        ></el-date-picker>
                                        <small
                                            class="form-control-feedback"
                                            v-if="errors.output_date"
                                            v-text="errors.output_date[0]"
                                        ></small>
                                    </div>
                                    <div
                                        class="col-6 form-group"
                                        :class="{ 'has-danger': errors.output_time }"
                                    >
                                        <label>Hora de salida</label>
                                        <el-input v-model="form.output_time" placeholder="HH:MM">
                                        </el-input>
                                        <small
                                            class="form-control-feedback"
                                            v-if="errors.output_time"
                                            v-text="errors.output_time[0]"
                                        ></small>
                                    </div>
                                </div>
                            </div>

                            
                            
                            <!-- mostrar campos adicionales para pago, si tiene estado pagado -->
                            <template v-if="isPaid">

                                <div class="col-12 col-md-3 form-group">
                                    <label class="label-control">
                                        Serie
                                    </label>
                                    <el-select v-model="document.series_id" placeholder="Selecciona una serie">
                                        <el-option v-for="serie in series"
                                            :key="serie.id"
                                            :value="serie.id"
                                            :label="serie.number"
                                        ></el-option>
                                    </el-select>
                                </div>
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12 text-right">
                                            <a href="#"
                                                @click.prevent="addRentPayment"
                                                class="text-center font-weight-bold text-info ml-3 pl-3">[+ Agregar]</a>
                                        </div>

                                        <template v-for="(rent_payment, index) in form.rent_payment">

                                            <div
                                                class="col-12 col-md-3 form-group"
                                                :class="{ 'has-danger': errors['rent_payment.payment_method_type_id'] }"
                                            >
                                                <label for="rate">Método de pago</label>

                                                <el-select
                                                    v-model="rent_payment.payment_method_type_id"
                                                    filterable
                                                >
                                                    <el-option
                                                        v-for="option in payment_method_types"
                                                        :key="option.id"
                                                        :value="option.id"
                                                        :label="option.description"
                                                    ></el-option>
                                                </el-select>

                                                <small
                                                    class="form-control-feedback"
                                                    v-if="errors['rent_payment.payment_method_type_id']"
                                                    v-text="errors['rent_payment.payment_method_type_id'][0]"
                                                ></small>
                                            </div>

                                            <div
                                                class="col-12 col-md-3 form-group"
                                                :class="{ 'has-danger': errors['rent_payment.payment_destination_id'] }"
                                            >
                                                <label for="rate">Destino</label>

                                                <el-select
                                                    v-model="rent_payment.payment_destination_id"
                                                    filterable
                                                >
                                                    <el-option
                                                        v-for="option in payment_destinations"
                                                        :key="option.id"
                                                        :value="option.id"
                                                        :label="option.description"
                                                    ></el-option>
                                                </el-select>

                                                <small
                                                    class="form-control-feedback"
                                                    v-if="errors['rent_payment.payment_destination_id']"
                                                    v-text="errors['rent_payment.payment_destination_id'][0]"
                                                ></small>
                                            </div>
                                            
                                            <div
                                                class="col-12 col-md-3 form-group"
                                            >
                                                <label for="rate">Referencia</label>

                                                <el-input
                                                    v-model="rent_payment.reference"
                                                ></el-input>
                                            </div>

                                            <div
                                                class="col-12 col-md-3 form-group"
                                            >
                                                <label>Monto</label>
                                                <el-input
                                                    v-model="rent_payment.payment"
                                                >
                                                    <el-button v-if="index !== 0"
                                                        type="danger"
                                                        size="mini"
                                                        slot="append"
                                                        class="custom-trash"
                                                        @click.prevent="removeRentPayment(index)"
                                                    >
                                                        <i class="fa fa-trash"></i>
                                                    </el-button>
                                                </el-input>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </template>

                        </div>
                        <div class="d-flex justify-content-between pt-5">
                            <el-button
                                type="primary"
                                :loading="loading"
                                :disabled="loading"
                                @click="onSubmit"
                            >Guardar
                            </el-button
                            >
                            <el-button @click="onToBackPage">Cancelar</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <person-form
            :showDialog.sync="showDialogNewPerson"
            type="customers"
            :external="true"
            :input_person="input_person"
            :document_type_id="form.document_type_id"
        ></person-form>

        <sale-notes-options :showDialog.sync="showDialogOptions"
                            :recordId="saleNotesNewId"
                            :showClose="true"
                            :configuration="config"
                            @returnBackPage="onToBackPage"
                            ></sale-notes-options>
    </div>
</template>

<script>

import PersonForm from "../../../../../../../resources/js/views/tenant/persons/form.vue";
import moment from "moment";
import {calculateRowItem} from "../../../../../../../resources/js/helpers/functions";
import {functions} from "../../../../../../../resources/js/mixins/functions";
import {mapActions,mapState} from "vuex/dist/vuex.mjs";
import SaleNotesOptions from "../../../../../../../resources/js/views/tenant/sale_notes/partials/options.vue"

export default {
    components: {
        PersonForm,
        SaleNotesOptions
    },
    mixins: [
        functions
    ],
    props: {
        configuration: {
            type: Object
        },
        room: {
            type: Object,
            required: true,
            default: {},
        },
        affectationIgvTypes: {
            type: Array,
            required: true,
        },
        series: {
            type: Array
        }
    },
    data() {
        return {
            customers: [],
            customer: {},
            customerId: null,
            customer_barcode: null,
            form: {
                customer: {},
                towels: 1,
                rate: {},
                duration: 1,
                total_to_pay: 0,
                output_time: "12:00",
                output_date: null,
                payment_status: 'PAID',
                quantity_persons: 2,
                affectation_igv_type_id: null,
                date_of_issue: moment().format("YYYY-MM-DD"),
                establishment_id: null,
                rent_payment: [{
                    payment_method_type_id: null,
                    payment_destination_id: 'cash', //null,
                    reference: null,
                    payment: 0,
                }],
                input_date: moment().format("YYYY-MM-DD"),
                input_time: "12:00",
            },
            rate: null,
            loading: false,
            showDialogNewPerson: false,
            search_item_by_barcode: false,
            input_person: {},
            configuration: {},
            errors: {
                customer: {},
            },
            recordItem: null,
            payment_method_types: [],
            payment_destinations: [],
            resource_document: 'sale-notes',
            document:{},
            showDialogOptions: false,
            saleNotesNewId: null,
        };
    },
    async mounted() {
        await this.onFetchTables();
        this.onUpdateOutputDate();
        this.initForm()
    },
    async created() {
        this.$store.commit('setConfiguration', this.configuration)
        this.loadConfiguration()
        await this.$eventHub.$on("reloadDataPersons", (customerId) => {
            this.reloadDataCustomers(customerId);
        });
    },
    computed: {
        isPaid()
        {
            return this.form.payment_status === 'PAID'
        },
        ...mapState([
            'config',
        ]),
        getAllowedAffectationIgvTypes: function () {
            return this.affectationIgvTypes.filter((item) => {
                return ['10', '20'].includes(item.id)
            })
        },
    },
    methods: {
        ...mapActions([
            'loadConfiguration',
        ]),
        async onSubmit() {
            this.loading = true;
            await this.$http
                .get(`/documents/search/item/${this.room.item_id}`)
                .then((response) => {

                    const payload = {};
                    const item = response.data.items[0];

                    payload.item = item;
                    payload.discounts = [];
                    payload.charges = [];
                    payload.attributes = [];
                    payload.item_unit_types = item.item_unit_types;
                    payload.unit_price_value = this.form.rate_price;
                    payload.has_igv = item.has_igv;
                    payload.has_plastic_bag_taxes = item.has_plastic_bag_taxes;

                    // payload.affectation_igv_type_id = item.sale_affectation_igv_type_id;

                    payload.affectation_igv_type_id = this.form.affectation_igv_type_id
                    payload.affectation_igv_type = _.find(this.affectationIgvTypes, {
                        id: payload.affectation_igv_type_id,
                    });


                    payload.quantity = this.form.duration;
                    const unit_price = item.has_igv
                        ? payload.unit_price_value
                        : payload.unit_price_value * (1 + this.percentage_igv);
                    payload.input_unit_price_value = payload.unit_price_value;
                    payload.unit_price = unit_price;
                    payload.item.unit_price = unit_price;
                    const currencyTypeIdActive = "PEN";
                    const exchangeRateSale = 0;
                    const product = calculateRowItem(
                        payload,
                        currencyTypeIdActive,
                        exchangeRateSale,
                        this.percentage_igv
                    );
                    this.form.product = product;
                    this.$http
                        .post(`/hotels/reception/${this.room.id}/rent/store`, this.form)
                        .then(async (response) => {
                            this.$message({
                                message: response.data.message,
                                type: "success",
                            });

                            // generar NV si estado es PAGADO
                            if (this.isPaid) {
                                this.document.items.push(product)
                                await this.saveSaleNote(response.data.rent_item_id)
                            } else {
                                this.onToBackPage();
                            }

                        })
                        .catch((error) => {
                            this.axiosError(error);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                })
                .finally(() => (this.loading = false));
        },
        onToBackPage() {
            window.location.href = "/hotels/reception";
        },
        onChangeStatusPayment() {
            if (this.form.payment_status === "DEBT") {
                this.form.payment_type = "CASH";
            }
        },
        onUpdateTotalToPay() {
            this.form.total_to_pay = this.form.rate_price * this.form.duration;
            this.onUpdateOutputDate();
            this.setTotalPayment()
        },
        setTotalPayment()
        {
            // this.form.rent_payment.payment = this.form.total_to_pay
            let payments_count = this.form.rent_payment.length
            let total = parseFloat(this.form.total_to_pay)
            let payment = 0
            let amount = _.round(total / payments_count, 2)

            this.form.rent_payment.forEach((row, index) => {
                payment += amount
                if (index === payments_count - 1) {
                    amount = _.round(total - (payment - amount), 2)
                }
                row.payment = amount
            })
        },
        onUpdateOutputDate() {
            const newDate = moment().add(this.form.duration, "days");
            this.form.output_date = newDate.format("YYYY-MM-DD");
        },
        onSelectedRate() {
            const rate = this.room.rates
                .filter((r) => r.hotel_rate_id === this.form.hotel_rate_id)
                .reduce((r) => r);
            this.rate = rate.rate;
            this.rate.price = rate.price;
            this.form.rate_price = rate.price;
            this.onUpdateTotalToPay();
        },
        async reloadDataCustomers(customerId) {
            await this.$http
                .get(`/persons/search/${customerId}`)
                .then((response) => {
                    this.customers = response.data.customers;
                    this.form.customer_id = customerId;
                    this.changeCustomer();
                });

        },
        keyupCustomer() {
            if (this.input_person.number) {
                if (!isNaN(parseInt(this.input_person.number))) {
                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = "1";
                            this.showDialogNewPerson = true;
                            break;

                        case 11:
                            this.input_person.identity_document_type_id = "6";
                            this.showDialogNewPerson = true;
                            break;
                        default:
                            this.input_person.identity_document_type_id = "6";
                            this.showDialogNewPerson = true;
                            break;
                    }
                }
            }
        },
        async onFetchTables() {
            this.loading = true;
            await this.$http
                .get("/hotels/reception/tables")
                .then((response) => {
                    this.customers = response.data.customers;
                    this.configuration = response.data.configuration
                    
                    this.payment_method_types = response.data.payment_method_types
                    this.payment_destinations = response.data.payment_destinations
                    this.setDefaultDataPayments()

                    this.setAffectationIgvType()
                })
                .finally(() => {
                    this.loading = false;
                });
            this.form.establishment_id = this.config.establishment.id;
            await this.getPercentageIgv();
        },
        setDefaultDataPayments()
        {
            // this.form.rent_payment.payment_method_type_id = this.payment_method_types.length > 0 ? this.payment_method_types[0].id : null
            this.form.rent_payment[0].payment_method_type_id = this.payment_method_types.length > 0 ? this.payment_method_types[0].id : null
        },
        setAffectationIgvType() {

            let affectation_igv_type = _.find(this.getAllowedAffectationIgvTypes, {id: this.configuration.affectation_igv_type_id})
            this.form.affectation_igv_type_id = (affectation_igv_type) ? affectation_igv_type.id : '10'

        },
        searchRemoteCustomers(input) {
            if (input.length > 0) {
                this.loading = true;

                const params = {
                    'input': input,
                    'search_by_barcode': this.search_item_by_barcode ? 1 : 0
                }
                this.$http
                    .get(`/hotels/reception/tables/customers`, {params})
                    .then((response) => {
                        this.customers = response.data.customers;

                        this.input_person.number = null;

                        if (this.customers.length == 0) {
                            this.input_person.number = input;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.input_person.number = null;
            }
        },
        changeCustomer() {
            this.customer = this.customers
                .filter((c) => c.id === this.form.customer_id)
                .reduce((c) => c);

            const main_address = this.customer.addresses.filter(address => address.main)
            this.form.customer = {...this.customer};
            this.form.customer.address = main_address.length ? main_address[0].address : null
            this.document.address_id = main_address.length ? main_address[0].id : null
        },
        onGetStatus(status) {
            if (status === "DISPONIBLE") {
                return "badge-success";
            }
            if (status === "OCUPADO") {
                return "badge-danger";
            }
            if (status === "MANTENIMIENTO") {
                return "badge-warning";
            }
            if (status === "LIMPIEZA") {
                return "badge-info";
            }
        },

        initForm() {
            this.document = {
                // serie_id: this.series.length ? this.series[0].id : null,
                document_type_id: '80',

                id: null,
                series_id: this.series.length ? this.series[0].id : null,
                prefix: 'NV',
                establishment_id: null,
                due_date: null,
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                customer_id: null,
                currency_type_id: this.config.currency_type_id,
                purchase_order: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                subtotal: 0,
                total_igv_free: 0,
                total: 0,
                operation_type_id: null,
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                payments: [],
                additional_information: null,
                actions: {
                    format_pdf: 'a4',
                },
                apply_concurrency: false,
                type_period: null,
                quantity_period: 0,
                automatic_date_of_issue: null,
                enabled_concurrency: false,
                license_plate: null,
                payment_method_type_id: null,
                paid: false,
                observation: null,
                terms_condition: null,

                type_device: 'web',

                dcto_monto_input: 0,
                dcto_totales_input: 0,
                monto_pagar_sin_dcto: 0,
                address_id: null,
                source_module: 'HOTEL_RENT'
            }
        },

        calculateTotal() {
            let total_discount = 0
            let total_charge = 0
            let total_exportation = 0
            let total_taxed = 0
            let total_exonerated = 0
            let total_unaffected = 0
            let total_free = 0
            let total_igv = 0
            let total_value = 0
            let total = 0
            let total_igv_free = 0

            this.document.items.forEach((row) => {
                total_discount += parseFloat(row.total_discount)
                total_charge += parseFloat(row.total_charge)

                if (row.affectation_igv_type_id === '10') {
                    total_taxed += parseFloat(row.total_value)
                }
                if (row.affectation_igv_type_id === '20'  // 20,Exonerado - Operación Onerosa
                    || row.affectation_igv_type_id === '21' // 21,Exonerado – Transferencia Gratuita
                ) {
                    total_exonerated += parseFloat(row.total_value)
                }
                if (
                    row.affectation_igv_type_id === '30'  // 30,Inafecto - Operación Onerosa
                    || row.affectation_igv_type_id === '31'  // 31,Inafecto – Retiro por Bonificación
                    || row.affectation_igv_type_id === '32'  // 32,Inafecto – Retiro
                    || row.affectation_igv_type_id === '33'  // 33,Inafecto – Retiro por Muestras Médicas
                    || row.affectation_igv_type_id === '34'  // 34,Inafecto - Retiro por Convenio Colectivo
                    || row.affectation_igv_type_id === '35'  // 35,Inafecto – Retiro por premio
                    || row.affectation_igv_type_id === '36' // 36,Inafecto - Retiro por publicidad
                    || row.affectation_igv_type_id === '37'  // 37,Inafecto - Transferencia gratuita
                ) {
                    total_unaffected += parseFloat(row.total_value)
                }
                if (row.affectation_igv_type_id === '40') {
                    total_exportation += parseFloat(row.total_value)
                }
                if (['10',
                    '20', '21',
                    '30', '31', '32', '33', '34', '35', '36',
                    '40'].indexOf(row.affectation_igv_type_id) < 0) {
                    total_free += parseFloat(row.total_value)
                }
                if (['10',
                    '20', '21',
                    '30', '31', '32', '33', '34', '35', '36',
                    '40'].indexOf(row.affectation_igv_type_id) > -1) {
                    total_igv += parseFloat(row.total_igv)
                    total += parseFloat(row.total)
                }


                if (['11', '12', '13', '14', '15', '16'].includes(row.affectation_igv_type_id)) {

                    let unit_value = row.total_value / row.quantity
                    let total_value_partial = unit_value * row.quantity
                    row.total_taxes = row.total_value - total_value_partial

                    row.total_igv = total_value_partial * (row.percentage_igv / 100)
                    row.total_base_igv = total_value_partial
                    total_value -= row.total_value

                    total_igv_free += row.total_igv
                }

                total_value += parseFloat(row.total_value)

            })

            this.document.total_igv_free = _.round(total_igv_free, 2)

            this.document.total_discount = _.round(total_discount, 2)
            this.document.total_exportation = _.round(total_exportation, 2)
            this.document.total_taxed = _.round(total_taxed, 2)
            this.document.total_taxed_without_rounding = _.round(total_taxed, 5)
            this.document.total_exonerated = _.round(total_exonerated, 2)
            this.document.total_unaffected = _.round(total_unaffected, 2)
            this.document.total_free = _.round(total_free, 2)
            this.document.total_igv = _.round(total_igv, 2)
            this.document.total_value = _.round(total_value, 2)
            this.document.total_taxes = _.round(total_igv, 2)

            this.document.subtotal = _.round(total, 2)
            this.document.total = _.round(total, 2)

            // this.monto_pagar_sin_dcto = this.document.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total_original, 0)
            this.document.monto_pagar_sin_dcto = this.document.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total_original, 0)
        },

        async saveSaleNote(rent_item_id) {
            this.loading = true
            this.calculateTotal()
            this.document.customer_id = this.form.customer_id
            this.document.establishment_id = this.form.establishment_id
            // add payments
            // this.document.payments.push({
            //     id: null,
            //     document_id: null,
            //     date_of_payment: moment().format('YYYY-MM-DD'),
            //     payment_method_type_id: this.form.rent_payment.payment_method_type_id, //'01', // método de pago
            //     reference: this.form.rent_payment.reference, // referencia
            //     payment_destination_id: this.form.rent_payment.payment_destination_id, // this.getPaymentDestinationId(), // destino
            //     payment: this.form.total_to_pay, // 0,

            //     filename: null,
            //     temp_path: null,
            //     file_list: [],
            // })
            this.form.rent_payment.forEach(payment => {
                this.document.payments.push({
                    id: null,
                    document_id: null,
                    date_of_payment: moment().format('YYYY-MM-DD'),
                    payment_method_type_id: payment.payment_method_type_id, //'01', // método de pago
                    reference: payment.reference, // referencia
                    payment_destination_id: payment.payment_destination_id, // this.getPaymentDestinationId(), // destino
                    payment: payment.payment, // 0,

                    filename: null,
                    temp_path: null,
                    file_list: [],
                })
            })
            // return
            
            const response = await this.$http.post(`/${this.resource_document}`, this.document)
            if (response.data.success) {
                const { id, cash_id } = response.data.data
                this.saleNotesNewId = id
                this.showDialogOptions = true
                this.$message({
                    message: 'Nota de venta guardada correctamente',
                    type: 'success',
                })
                await this.saveCashDocument(id, cash_id)
                await this.updateRentItem(rent_item_id, id)
            } else {
                console.log('Error al guardar la nota de venta')
            }
            this.loading = false
        },

        async saveCashDocument(documentId, cashId) {
            const response = await this.$http.post(`/cash/cash_document`, {
                document_id: null,
                sale_note_id: documentId,
                cash_id: cashId,
            })
        },

        async updateRentItem(rent_item_id, sale_note_id) {
            const response = await this.$http.post(`/hotels/reception/rent-item-update`, {
                rent_item_id,
                sale_note_id
            })
        },

        addRentPayment() {
            this.form.rent_payment.push({
                payment_method_type_id: this.payment_method_types.length > 0 ? this.payment_method_types[0].id : null,
                payment_destination_id: 'cash',
                reference: null,
                payment: 0,
            })
            this.setTotalPayment()
        },

        removeRentPayment(index) {
            this.form.rent_payment.splice(index, 1)
            this.setTotalPayment()
        }
    },
};
</script>

<style scoped>
    .custom-trash {
        background: rgb(247, 23, 23) !important;
        color: rgb(231, 229, 229) !important;
        transition: all 0.3s ease;
    }
    .custom-trash:hover {
        background: rgba(247, 23, 23, 0.788) !important;
        color: rgb(231, 229, 229) !important;
    }
</style>


// WEBPACK FOOTER //
// modules/Hotel/Resources/assets/js/views/rooms/Rent.vue